import { render } from "./MarketplaceFavs.vue?vue&type=template&id=62a102b2&scoped=true"
import script from "./MarketplaceFavs.vue?vue&type=script&lang=js"
export * from "./MarketplaceFavs.vue?vue&type=script&lang=js"

import "./MarketplaceFavs.vue?vue&type=style&index=0&id=62a102b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a102b2"]])

export default __exports__